<template>
  <div class="banner">
    <div class="column column1">
      <div class="title">Where to get the code</div>
    </div>
    <div class="column column2">
      <div class="mediumTitle">
        Code, installation, and admin documentation available in this
        <a
          class="link"
          href="https://github.com/myplanet/askaway"
          target="_blank"
        >Github repo</a>.
      </div>
      <div class="subheading">
        Askaway is licensed as GNU AGPLv3.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner1",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  display: flex;
  justify-content: space-between;
  background-color: #f25930;
  margin: 0 auto;
  width: 60%;
  height: 375px;
  padding: 80px;
  margin-bottom: 40px;
  color: #fff;
  z-index: 1;
}
.banner .link {
  color: #fff;
  text-decoration: underline;
}
.column {
  display: flex;
  width: 40%;
  margin: 20px;
  margin-right: 40px;
}

.column2 {
  flex-direction: column;
  width: 60%;
  text-align: left;
  margin-right: 20px;
}

.banner .title {
  font-size: 40px;
  text-align: left;
  line-height: 50px;
  font-family: "SofiaProBold";
}

.banner .mediumTitle {
  font-size: 22px;
  line-height: 38px;
}
.banner .subheading {
  font-size: 22px;
  line-height: 27px;
  margin-top: 15px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .banner {
    width: 80%;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .banner {
    width: 80%;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .banner {
    width: 100%;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .banner {
    width: 100%;
    margin: 0 auto;
    padding: 40px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .banner .title {
    font-size: 30px;
    line-height: 40px;
  }

  .banner .mediumTitle {
    font-size: 20px;
    line-height: 26.66px;
  }

  .banner .subheading {
    font-size: 20px;
    line-height: 26.66px;
    margin-top: 15px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .banner {
    width: 100%;
    height: 300px;
    margin: 0 auto;
    padding: 60px;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
  }

  .banner .title {
    font-size: 20px;
    line-height: 26.66px;
    font-family: "SofiaProBold";
  }

  .column {
    margin: 10px;
  }

  .banner .mediumTitle {
    font-size: 16px;
    line-height: 21.33px;
  }
  .banner .subheading {
    font-size: 16px;
    line-height: 21.33px;
    margin-top: 15px;
  }
}

</style>
